import { TableFromFile } from '../../Tsv_parser';
import { useText } from '../../../../hooks/useText';

export const StatisticsTable = () => {
  const version = process.env.REACT_APP_RELEASE_VERSION || 'v253';
  const suffix = version === 'v254' ? '_v254' : '';

  // Text CMS keys
  const titleGDAs = useText('about.statistics.gdas_title', 'Distribution of genes, diseases, and GDAs by source');
  const titleVDAs = useText('about.statistics.vdas_title', 'Distribution of variants, diseases, and VDAs by source');
  const titleCoverage = useText('about.statistics.coverage_title', 'DISGENET provides ample coverage of all disease areas...');
  const titleProteinClasses = useText('about.statistics.protein_classes_title', '...and protein classes relevant for chemical R&D');
  
  const labelSource = useText('about.statistics.label_source', 'Source');
  const labelGenes = useText('about.statistics.label_genes', 'Genes');
  const labelDiseases = useText('about.statistics.label_diseases', 'Diseases');
  const labelGDAs = useText('about.statistics.label_gdas', 'GDAs');
  const labelVariants = useText('about.statistics.label_variants', 'Variants');
  const labelVDAs = useText('about.statistics.label_vdas', 'VDAs');
  const labelEvidences = useText('about.statistics.label_evidences', 'Evidences');
  
  const altTherapeuticAreas = useText('about.statistics.alt_therapeutic_areas', 'DISGENET therapeutic areas');
  const altProteinClasses = useText('about.statistics.alt_protein_classes', 'DISGENET protein classes');

  return (
    <>
      <h3 className="mt-5 text-lg font-semibold">{titleGDAs}</h3>
      <div className="overflow-x-auto">
        <table className="table panther-table mx-2 my-2 mb-10 mr-5">
          <thead className="text-center">
            <tr>
              <th>{labelSource}</th>
              <th>{labelGenes}</th>
              <th>{labelDiseases}</th>
              <th>{labelGDAs}</th>
              <th>{labelEvidences}</th>
            </tr>
          </thead>
          <tbody className="text-center">
            <TableFromFile filePath={`/static/files/gdas_stats${suffix}.tsv`} />
          </tbody>
        </table>
      </div>

      <h3 className="mt-5 text-lg font-semibold">{titleVDAs}</h3>
      <div className="overflow-x-auto">
        <table className="table panther-table mx-2 my-2 mb-10 mr-5">
          <thead className="text-center">
            <tr>
              <th>{labelSource}</th>
              <th>{labelVariants}</th>
              <th>{labelDiseases}</th>
              <th>{labelVDAs}</th>
              <th>{labelEvidences}</th>
            </tr>
          </thead>
          <tbody className="text-center">
            <TableFromFile filePath={`/static/files/vdas_stats${suffix}.tsv`} />
          </tbody>
        </table>
      </div>

      <h3 className="mt-5 text-lg font-semibold">{titleCoverage}</h3>
      <img
        src="/static/images/plot_msh.svg"
        className="mx-2 my-5 ml-2 w-full h-auto"
        alt={altTherapeuticAreas}
      />

      <h3 className="mt-5 text-lg font-semibold">{titleProteinClasses}</h3>
      <img
        src="/static/images/plot_dto.svg"
        className="mx-2 my-5 ml-2 w-full h-auto"
        alt={altProteinClasses}
      />
    </>
  );
};
